import { useEffect, useRef, useState } from 'react';
import TopicEdit from './TopicEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import { Space, Tag } from 'antd';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'topic';

    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>();
    const [topicGroupData, setTopicGroupData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFetchData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService, {
            query: {
                apiId: 'topicGroup',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setTopicGroupData([{ id: 'ALLITEM', groupName: '所有' }, ...res.data]);
            }
        });
    }, []);

    // 表头
    const columnsHead = [
        {
            title: '主题组',
            dataIndex: 'topicGroup',
            render: (val: any) => val?.groupName || '-'
        },
        {
            title: '主题名',
            dataIndex: 'topicName'
        },
        {
            title: '主题',
            dataIndex: 'topicStr'
        },
        {
            title: '副主题',
            dataIndex: 'topicEx',
            render: (val: string) => val || '-'
        },
        {
            title: '可回复',
            dataIndex: 'isReply',
            render: (val: boolean) =>
                val
                    ? <Tag color="blue">是</Tag>
                    : <Tag>否</Tag>
        },
        {
            title: '排序',
            dataIndex: 'sort'
        },
        {
            title: '状态',
            dataIndex: 'isUse',
            render: (val: boolean) =>
                val
                    ? <Tag color="green">启用</Tag>
                    : <Tag color="red">关闭</Tag>
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '主题',
        apiId,
        columns,
        serviceId: 'mf',
        editOptions: {
            Editor: TopicEdit
        }
    };

    return (
        <>
            <Space>
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='topicGroupId'
                    getListData={topicGroupData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                    itemName="groupName"
                />
            </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
        </>
    );
};

export default WebComponent;